import type { CloneReason } from "../MetadocConstants";
import { CLONE_REASONS } from "../MetadocConstants";

import type { GroupingSource } from "services/metadoc-api";

export type WorkspaceViewContext = {
  cloneReason: CloneReason | null;
  groupingSource: GroupingSource;
  canShowGroupingToggle: boolean;
  hasPreAiRunDownloadUrl: boolean;
};

export type WorkspaceViewDecision = {
  isAiAnalysisCloneView: boolean;
  effectiveGroupingSource: GroupingSource;
  canShowGroupingToggle: boolean;
  isOpsPostAiReadOnly: boolean;
};

/* resolves workspace grouping/toggle/read-only policy from clone reason + source state */
export const getWorkspaceViewDecision = (
  context: WorkspaceViewContext,
): WorkspaceViewDecision => {
  const {
    cloneReason,
    groupingSource,
    canShowGroupingToggle,
    hasPreAiRunDownloadUrl,
  } = context;
  const baseDecision: WorkspaceViewDecision = {
    isAiAnalysisCloneView: false,
    effectiveGroupingSource: groupingSource,
    canShowGroupingToggle,
    isOpsPostAiReadOnly: groupingSource === "OPS" && hasPreAiRunDownloadUrl,
  };

  // ai-analysis clones always open in ops and should not show analyst toggle.
  if (cloneReason === CLONE_REASONS.AI_ANALYSIS) {
    return {
      isAiAnalysisCloneView: true,
      effectiveGroupingSource: "OPS",
      canShowGroupingToggle: false,
      // ai-analysis clones still need selective ops readonly behavior even
      // when they now resolve directly from the download url.
      isOpsPostAiReadOnly: true,
    };
  }

  // null or any non-ai clone reason keeps the caller-provided grouping behavior.
  return baseDecision;
};
